module.exports = __webpack_public_path__ + "img/schedule-right-icon.4843d13b.svg";